import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import { successfulUpdate } from '@/helpers/mixins/LocalizationHelper';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
import FaqForm from '@/components/v2/FaqForm.vue';
import FaqDetails from '@/plugins/graphql/queries/v2/faq.gql';
import { FaqInputModel } from '@/helpers/entities/models/FaqInputModel';
import FaqMixin from '@/helpers/vue_mixins/v2/ecommerce/FaqMixin';
import FaqUpdate from '@/plugins/graphql/mutations/v2/faq-update.gql';
import FaqUploadImages from '@/plugins/graphql/mutations/v2/faq-upload-images.gql';
import FaqRemoveImages from '@/plugins/graphql/mutations/v2/faq-remove-images.gql';
import FaqFragment from '@/plugins/graphql/fragments/v2/faq.gql';
import { FileUploadInputModel } from '@/helpers/entities/models/FileUploadInputModel';
import ImageUploadMixin from '@/helpers/vue_mixins/v2/ImageUploadMixin';
import { isNotEmpty } from '@/helpers';
let FaqEdit = class FaqEdit extends mixins(AlertMixin, RouterParamsAppMixin, FaqMixin, CleverTapEventsMixin, ImageUploadMixin) {
    constructor() {
        super(...arguments);
        this.faq = null;
    }
    get queryOnFlight() {
        return this.$apollo.queries.faq.loading;
    }
    get formData() {
        const { faq } = this;
        const data = {
            question: null,
            answer: null,
            active: true,
            images: [],
        };
        if (faq) {
            const { uuid, active, question, answer, images } = faq;
            const images_data = images.map((image) => new FileUploadInputModel(image));
            return {
                uuid,
                question,
                answer,
                active,
                images: images_data,
            };
        }
        return data;
    }
    async onSubmit(form) {
        this.mutationRequestOnFlight();
        await this.update(form)
            .then(() => {
            const msg = successfulUpdate('FAQ');
            this.voucherAction('SUBMIT EDIT');
            this.successNotification(msg);
            this.goToFaqsPage();
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async update(form) {
        try {
            const { question, answer, active } = form;
            const faqUUID = form.uuid;
            await this.$apollo.mutate({
                mutation: FaqUpdate,
                variables: {
                    input: {
                        question,
                        answer,
                        active,
                        faqUuid: this.uuid,
                    },
                },
                update(cache, { data }) {
                    const { faq } = data.faqUpdate;
                    faq.uuid = faqUUID;
                    cache.writeFragment({
                        id: faqUUID,
                        fragment: FaqFragment,
                        data: faq,
                        fragmentName: 'Faq',
                    });
                    cache.writeQuery({
                        query: FaqDetails,
                        variables: {
                            faqUUID,
                        },
                        data: {
                            fetchSpecificFaq: faq,
                        },
                    });
                },
            });
            if (form.images.length > 0) {
                const deletedImagesUuids = this.getDeletedImageUuids(form.images);
                const newImages = this.filterNewImages(form.images);
                if (isNotEmpty(deletedImagesUuids.length)) {
                    await this.deleteImages(deletedImagesUuids);
                }
                if (isNotEmpty(newImages.length)) {
                    await this.imageUploader(newImages);
                }
            }
        }
        catch (error) {
            console.error('Error during FAQ update mutation: ', error);
            throw error;
        }
    }
    async imageUploader(images) {
        const inputImages = images.map((input) => input.file);
        await this.$apollo.mutate({
            mutation: FaqUploadImages,
            variables: {
                input: {
                    faqUuid: this.uuid,
                    images: inputImages,
                },
            },
        });
    }
    async deleteImages(imageUuids) {
        await this.$apollo.mutate({
            mutation: FaqRemoveImages,
            variables: {
                input: {
                    faqUuid: this.uuid,
                    photos: imageUuids,
                },
            },
        });
    }
};
__decorate([
    Prop({ type: String, required: true })
], FaqEdit.prototype, "uuid", void 0);
FaqEdit = __decorate([
    Component({
        components: {
            PageTitle,
            FaqForm,
        },
        apollo: {
            faq: {
                query: FaqDetails,
                variables() {
                    const faqUuid = this.uuid;
                    return {
                        faqUuid,
                    };
                },
                update(data) {
                    return new FaqInputModel(data.fetchSpecificFaq);
                },
            },
        },
    })
], FaqEdit);
export default FaqEdit;
